import { createFileRoute } from "@tanstack/react-router";

import { LastAnalysis } from "@/features/analysis";
import { Greeting } from "@/features/auth";
import { DrillOfTheDay, DrillsNowLink } from "@/features/drills";
import { HighlightsStrip, MatchHighlightsBadge } from "@/features/highlights";
import {
  HistorySince,
  MatchList,
  matchFiltersSchema,
  NoNewMatches,
  RecentSummary,
  YourHeroes,
} from "@/features/matches";

// Главная по макету design/prototype/Home.dc.html: приветствие, «Новых матчей пока нет»
// с тренировкой на это время (ReturnNoMatches.dc.html), сводка, «Твои лучшие моменты»
// (HighlightsHome.dc.html), последний разбор, матчи с фильтрами и значком хайлайтов матча
// (HighlightsEntry.dc.html), «Тренировка дня»
// (DrillHome.dc.html) и «Твои герои». Блоки читают
// кэши `GET /api/matches`, сводку игрока `GET /api/stats/summary` (быстрый разбор)
// и сводку тренировки `GET /api/drills/overview`.
// Фильтры списка — в search params; меняются без новой записи в истории браузера.
const HomePage = () => {
  const filters = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <main
      data-page="home"
      className="mx-auto flex w-full max-w-[1200px] flex-col gap-5 px-6 pt-6 pb-16"
    >
      <div className="flex flex-wrap items-end justify-between gap-2.5">
        <Greeting />
        <HistorySince />
      </div>
      <NoNewMatches secondaryAction={<DrillsNowLink />} />
      <RecentSummary />
      <HighlightsStrip />
      <LastAnalysis />
      <div className="flex flex-wrap items-start gap-5">
        <div className="min-w-0 flex-[999_1_560px]">
          <MatchList
            filters={filters}
            onFiltersChange={(next) => void navigate({ search: next, replace: true })}
            renderBadge={(matchId) => <MatchHighlightsBadge matchId={matchId} />}
          />
        </div>
        <div className="flex min-w-0 flex-[1_1_320px] flex-col gap-5 empty:hidden">
          <DrillOfTheDay />
          <YourHeroes />
        </div>
      </div>
    </main>
  );
};

export const Route = createFileRoute("/")({
  validateSearch: matchFiltersSchema,
  component: HomePage,
});
